module.exports = __webpack_public_path__ + "static/media/Machine_scheduler_template_1.d9eaff0a.png";